import { useState, useEffect } from 'react';

export function LiveStatus() {
  const [isLive, setIsLive] = useState(false);
  const [pulse, setPulse] = useState(true);

  useEffect(() => {
    // Simulate live status check - in production, this would be an API call
    const checkLiveStatus = () => {
      // For demo purposes, randomly set live status
      const now = new Date();
      const hour = now.getHours();
      // Example: Live between 7 PM - 9 PM IST
      setIsLive(hour >= 19 && hour < 21);
    };

    checkLiveStatus();
    const interval = setInterval(checkLiveStatus, 60000); // Check every minute

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isLive) {
      const pulseInterval = setInterval(() => {
        setPulse(prev => !prev);
      }, 1000);
      return () => clearInterval(pulseInterval);
    }
  }, [isLive]);

  return (
    <section className="py-8 bg-white border-y border-rose-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6">
          {/* Live Indicator */}
          <div className="flex items-center gap-4 bg-gradient-to-r from-rose-50 to-amber-50 px-8 py-4 rounded-full border-2 border-rose-200">
            <div className="relative">
              <div className={`w-4 h-4 rounded-full ${isLive ? 'bg-red-600' : 'bg-gray-400'} transition-all duration-300`}></div>
              {isLive && (
                <>
                  <div className={`absolute inset-0 w-4 h-4 rounded-full bg-red-600 ${pulse ? 'animate-ping' : ''}`}></div>
                  <div className="absolute inset-0 w-4 h-4 rounded-full bg-red-600 opacity-75 animate-pulse"></div>
                </>
              )}
            </div>
            <div>
              <p className="font-bold text-lg text-gray-900" style={{ fontFamily: "'Cinzel', serif" }}>
                {isLive ? 'LIVE NOW' : 'Currently Offline'}
              </p>
              <p className="text-sm text-gray-600">
                {isLive ? 'Answering AM Questions' : 'Next session coming soon'}
              </p>
            </div>
          </div>

          {/* Quick Action */}
          {isLive && (
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="px-6 py-3 bg-gradient-to-r from-rose-800 to-red-900 text-white rounded-full font-semibold hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-question-answer-line text-lg"></i>
              </div>
              Ask Your Question
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
